// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chat-sentiment-solid';

export const Component = () => (
  <path d='M23.037 1H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 2.485v15.661c0 .431.144.767.431 1.054.288.288.623.431 1.054.431H13.89c.144 0 .24.048.288.096l4.837 3.64c.24.144.479.192.623.192a.947.947 0 0 0 .67-.288.976.976 0 0 0 .288-.719v-2.92h2.442c.431 0 .766-.145 1.054-.432.287-.287.43-.623.43-1.054V2.486c0-.432-.143-.767-.43-1.055A1.408 1.408 0 0 0 23.037 1ZM16.57 13.548c-1.054 1.437-2.49 2.156-4.31 2.156-1.82 0-3.257-.719-4.31-2.156-.048-.143-.096-.239-.096-.287 0-.335.143-.479.479-.479.191 0 .335.048.43.191.911 1.198 2.108 1.772 3.497 1.772 1.389 0 2.586-.575 3.496-1.772.096-.143.24-.191.431-.191.335 0 .48.144.48.479 0 .144-.048.239-.097.287Z' />
);

export const viewBox = '0 0 25 25';
